import { Node, mergeAttributes } from '@tiptap/core'
import { ReactNodeViewRenderer } from '@tiptap/react'
import StComponent from './StComponent'

const StNode = Node.create({
  name: 'stNode',
  group: 'inline',
  inline: true,
  atom: true,
  selectable: true,
  draggable: true,

  addAttributes() {
    return {
      stName: {
        default: '',
        parseHTML: element => element.getAttribute('data-st-name'),
        renderHTML: attributes => {
          if (!attributes.stName) {
            return {}
          }
          return { 'data-st-name': attributes.stName }
        }
      }
    }
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-st-node]',
        getAttrs: node => {
          if (node instanceof HTMLElement) {
            const name = node.getAttribute('data-st-name')
            return name ? { stName: name } : {}
          }
          return {}
        }
      }
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(HTMLAttributes, { 'data-st-node': '' }),
      `{{st '${HTMLAttributes.stName}'}}`
    ]
  },

  addNodeView() {
    return ReactNodeViewRenderer(StComponent)
  }
})

export default StNode
